import { makeStyles, Typography } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';

interface Props {
    title: string;
    variant?: Variant;
}
const useStyles = makeStyles({
    invisTitle: {
        opacity: 0,
        position: 'fixed',
        visibility: 'hidden',
        pointerEvents: 'none'
    }
});

const InvisibleTitle = ({ title, variant = 'h1' }: Props) => {
    const classes = useStyles();
    return (
        <Typography className={classes.invisTitle} variant={variant}>
            {title}
        </Typography>
    );
};

export default InvisibleTitle;
